<template>
    <div class="sign-record-page">
        <van-sticky>
            <div class="search-bar">
                <van-search v-model="filters.contractNumber" placeholder="请输入搜索合同编号" @search="onSearch" />
                <van-button type="primary" size="small" @click="showFilterPopup = true">筛选</van-button>
            </div>
        </van-sticky>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoadMore">
                <div v-for="(item) in list" :key="item.id" class="card">
                    <div class="card-body">
                        <div class="row"><label>合同编号</label>
                            <div class="value">
                                <ex-fold-table-cell v-if="item.sequencingContractDTO?.length > 0"
                                    :scope="{ text: item.sequencingContractDTO.map(it => it.contractNumber), item, index: item.id }"></ex-fold-table-cell>
                            </div>
                        </div>
                        <div class="row"><label>签署链接</label>
                            <div class="value">
                                <div v-if="item.signUrl && !item.annex">
                                    <span>{{ item.signUrl }}</span>
                                    <el-tooltip content="复制">
                                        <a-icon type="copy" style="color: #3f9dfe" @click="copyData(item.signUrl)" />
                                    </el-tooltip>
                                </div>
                                <div v-else-if="item.annex">
                                    NA
                                </div>
                            </div>
                        </div>
                        <div class="row"><label>签署标题</label>
                            <div class="value">{{ item.signTitle }}</div>
                        </div>
                        <div class="row"><label>签署人名称</label>
                            <div class="value">{{ item.signName }}</div>
                        </div>
                        <div class="row"><label>签署人电话</label>
                            <div class="value">{{ item.signPhone }}</div>
                        </div>
                        <div class="row"><label>签署状态</label>
                            <div class="value">
                                <el-tag :type="getSignColor(item.signStatus, 'tagType')"
                                    :style="{ color: getSignColor(item.signStatus, 'color'), 'background-color': getSignColor(item.signStatus, 'backgroundColor')}"><i
                                        :class="getSignColor(item.signStatus, 'icon')"></i>
                                    {{ getSignColor(item.signStatus, 'name') + (item.signStatus === 'SIGNED' ?
                                    (!item.annex ? '(线上)' :
                                    '(线下)')
                                    : '')
                                    }}</el-tag>
                            </div>
                        </div>
                        <div class="row" v-if="item.signStatus === 'VISA_REFUSAL'"><label>拒签原因</label>
                            <div class="value">{{ item.resultDescription }}</div>
                        </div>
                        <div class="row" v-if="item.signStatus === 'INITIATION_FAILED'"><label>签署发起失败原因</label>
                            <div class="value">{{ item.failReason }}</div>
                        </div>
                        <div class="row"><label>销售</label>
                            <div class="value">{{ item.sequencingContractDTO?.[0]?.sales?.name ?? '' }}</div>
                        </div>
                        <div class="row"><label>创建人</label>
                            <div class="value">{{ item.createBy }}</div>
                        </div>
                        <div class="row"><label>创建时间</label>
                            <div class="value">{{ item.createTime }}</div>
                        </div>
                        <div class="row"><label>备注</label>
                            <div class="value">{{ item.remark }}</div>
                        </div>
                        <div class="ops">
                            <van-button v-if="(item.signStatus === 'SIGNED' || !!item.annex)" size="mini" type="primary"
                                @click="downloadSignFile(item)">下载签署文件</van-button>
                            <van-button v-if="['OPERATOR_READ', 'SIGN_FLOW_INITIATED'].includes(item.signStatus)"
                                size="mini" type="danger" @click="handleRevoke(item)">撤销签署
                            </van-button>
                            <van-button size="mini" plain @click="viewSignInfo(item)">查看签署信息</van-button>
                        </div>
                    </div>
                </div>
            </van-list>
        </van-pull-refresh>
        <!-- 筛选弹窗 -->
        <van-popup v-model="showFilterPopup" position="right" :style="{ width: '85%', height: '100%' }">
            <van-nav-bar title="筛选条件" left-text="取消" right-text="确定" @click-left="showFilterPopup = false"
                @click-right="handleFilterConfirm" />
            <div class="filter-content">
                <van-field label-width="4.1em" label="合同编号" v-model="filters.contractNumber" placeholder="请输入合同编号" />
                <van-field label-width="4.1em" label="签署状态">
                    <template #input>
                        <van-radio-group style="width: 100%;" v-model="filters.signStatus" icon-size="15px">
                            <van-row>
                                <van-col span="12">
                                    <van-radio name="SIGN_FLOW_INITIATED">签署已发起</van-radio>
                                </van-col>
                                <van-col span="12">
                                    <van-radio name="OPERATOR_READ">甲方已读</van-radio>
                                </van-col>
                            </van-row>
                            <van-row>
                                <van-col span="12">
                                    <van-radio name="SIGNED">甲方已签</van-radio>
                                </van-col>
                                <van-col span="12">
                                    <van-radio name="VISA_REFUSAL">甲方拒签</van-radio>
                                </van-col>
                            </van-row>
                            <van-row>
                                <van-col span="12">
                                    <van-radio name="INITIATION_FAILED">签署发起失败</van-radio>
                                </van-col>
                                <van-col span="12">
                                    <van-radio name="RETRACTED">已撤销</van-radio>
                                </van-col>
                            </van-row>
                        </van-radio-group>
                    </template>
                </van-field>
                <van-field label-width="4.1em" label="签署标题" v-model="filters.signTitle" placeholder="请输入签署标题" />
                <van-field label-width="4.1em" label="签署人名称" v-model="filters.signName" placeholder="请输入签署人名称" />
                <van-field label-width="4.1em" label="签署人电话" v-model="filters.signPhone" placeholder="请输入签署人电话" />
            </div>
        </van-popup>
    </div>
</template>

<script>
import { getContractSignPage, revokeSign } from "@/api/dilivery/sign";
import { getSignColor } from "@/color";
import { saveDataToLocalStorage,getDataInLocalStorage } from "@/utils/localStorage";
import ExFoldTableCell from "@/components/ExFoldTableCell.vue";
import { copyText } from "@/utils/windowsUtils";
const baseURL = process.env.VUE_APP_BASE_API;

export default {
    name: "SignRecord",
    components: { ExFoldTableCell },
    data() {
        return {
            list: [],
            loading: false,
            finished: false,
            refreshing: false,
            loadding: false,
            page: {
                currentNum: 1,
                pageSize: 10,
                total: 0
            },
            showFilterPopup: false,
            filters: {
                contractNumber: '',
                signStatus: '',
                signName: '',
                signPhone: '',
                signTitle: ''
            }
        };
    },
    methods: {
        getSignColor,
        copyData(text) {
            copyText(text)
            this.$messageUi.success('复制成功')
        },
        handleRevoke(row) {
            this.$dialog.confirm({
                title: '提示',
                message: '是否撤销合同签署?',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                className: 'confirm-dialog'
            }).then(() => {
                revokeSign(row.id).then(res => {
                    if (res.code === 200) {
                        Toast.success('合同签署撤销成功')
                        this.getData(true)
                    } else {
                        Toast.fail('合同签署撤销失败')
                    }
                }).catch(err => {
                    Toast.fail('合同签署撤销失败')
                    console.error(err)
                })
            }).catch(() => {
                // 用户取消操作
            });
        },
        onLoadMore() {
            if (this.finished || this.loadding) {
                this.loading = false;
                return
            };
            this.page.currentNum = this.page.currentNum + 1;
            this.getData(false);
        },
        onRefresh() {
            this.refreshing = true;
            this.getData(true);
        },
        onSearch() {
            this.getData(true);
        },
        handleFilterConfirm() {
            this.showFilterPopup = false;
            this.getData(true);
        },
        async getData(reset = false) {
            if (reset) {
                this.page.currentNum = 1;
                this.list = [];
                this.finished = false;
            }
            this.loading = true;
            const params = {
                'page.current': this.page.currentNum,
                'page.size': this.page.pageSize
            };
            try {
                let sendData = {};
                // 添加筛选条件
                if (this.filters.contractNumber) sendData["contractNumber"] = this.filters.contractNumber;
                if (this.filters.signStatus) sendData["query#signStatus.EQ"] = this.filters.signStatus;
                if (this.filters.signName) sendData["query#signName.LIKE"] = this.filters.signName;
                if (this.filters.signPhone) sendData["query#signPhone.LIKE"] = this.filters.signPhone;
                if (this.filters.signTitle) sendData["query#signTitle.LIKE"] = this.filters.signTitle;

                const res = await getContractSignPage(params, sendData);
                if (res.code === 200) {
                    const records = Array.isArray(res.data.records) ? res.data.records : [];
                    if (this.page.currentNum === 1) {
                        this.list = records;
                    } else {
                        this.list = this.list.concat(records);
                    }
                    this.page.currentNum = parseInt(res.data.current);
                    this.page.pageSize = parseInt(res.data.size);
                    this.page.total = parseInt(res.data.total);
                    this.finished = this.list.length >= this.page.total;
                }
            } catch (err) {
                console.error("获取合同签署记录失败", err);
            } finally {
                this.loadding = false;
                this.refreshing = false;
                this.loading = false;
            }
        },
        viewSignInfo(item) {
            saveDataToLocalStorage('mSignData', JSON.stringify(item.sequencingContractDTO));
            this.$router.push({ path: '/showSignInfo' });
        },
        async downloadSignFile(item) {
            try {
                let url = `${baseURL}/contract-sign/download-file/${item.id}?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`;
                const a = document.createElement('a');
                a.href = url;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            } catch (e) {
                console.error(e);
            }
        }
    },
    mounted() {
        this.getData(true);
    }
};
</script>

<style scoped>
.sign-record-page {
    padding: 12px;
    padding-bottom: calc(12px + constant(safe-area-inset-bottom));
    padding-bottom: calc(12px + env(safe-area-inset-bottom));
    background: #f7f8fa;
    min-height: calc(100vh - 50px);
    box-sizing: border-box;
}

.card {
    background: #fff;
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 12px;
    box-shadow: 0 2px 12px rgba(100, 101, 103, 0.08);
    transition: all 0.3s;
}
.search-bar {
    display: flex;
    gap: 12px;
    align-items: center;
    background: #fff;
    padding: 16px;
    margin-bottom: 12px;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(100, 101, 103, 0.08);
}
.van-search {
    flex: 1;
}

.van-search__content {
    border-radius: 20px;
}
.van-field {

    border-radius: 8px;
}

.van-cell-group {
    margin-bottom: 16px;
    border-radius: 8px;
    overflow: hidden;
}

.van-cell {
    padding: 12px 16px;

}
.filter-content {
    height: calc(100% - 46px);
    overflow-y: auto;
    padding: 16px;
}

.confirm-dialog {
    .van-dialog__message {
        text-align: center;
        padding: 20px;
    }

    .van-dialog__footer {
        padding: 10px 20px 20px;
    }
}

.van-nav-bar {
    background: #fff;
}
.card:hover {
    box-shadow: 0 4px 16px rgba(100, 101, 103, 0.12);
}

.card-body {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 0;
}

.row label {
    color: #969799;
    width: 100px;
    font-size: 14px;
    font-weight: 500;
}

.row .value {
    color: #323233;
    flex: 1;
    text-align: right;
    font-size: 14px;
    font-weight: 500;
}

.ops {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid #ebedf0;
}

.ops .van-button {
    min-width: 70px;
    height: 32px;
    line-height: 30px;
    border-radius: 16px;
}
</style>
